import React from 'react';
import {
    Row,
    Col,
    Divider,
    Input,
    Typography,
    Form,
    Button,
    Select,
    Checkbox,
    DatePicker,
    message,
    Statistic,
    Skeleton,
    Result
} from 'antd';
import {
    FaSave
} from "react-icons/fa";
import { useParams, useNavigate } from 'react-router-dom';
import {
    useQuery,
    useMutation,
    // useQueryClient
} from '@tanstack/react-query';
// import axios from '../../config/axios';
import dayjs from 'dayjs';
import { paymentTypes } from '../../utils/customFunctions';
import AddProduct from './components/AddProduct';
import OrderItems from './components/OrderItems';
import axios from '../../config/axios';
function Create() {
    const { orderId } = useParams();
    const [form] = Form.useForm();
    const redirect = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const newOrderQuery = useQuery({ queryKey: ['/api/orders/getNewOrder'] });
    const studentsQuery = useQuery({ queryKey: ['/api/students/'] });
    const coursesQuery = useQuery({ queryKey: ['/api/products/getActiveCourses'] });
    const productsQuery = useQuery({ queryKey: ['/api/products/getActiveProducts'] });
    const orderItemsQuery = useQuery({ queryKey: [`/api/orderItems/getOrderDetail/${orderId}`] });

    const { mutate, isLoading } = useMutation({
        mutationFn: info => {
            axios
                .put(`/api/orders/${orderId}`, info)
                .then(res => {
                    // console.log(res);
                    messageApi.open({
                        type: 'success',
                        content: 'Create successfully',
                        duration: 1,
                        onClose: () => redirect(`/admin/orders/${res.data._id}`)
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Something went wrong please check you data or contact Admin.',
                    });
                })
        },
    });

    if (
        studentsQuery.isLoading
        || coursesQuery.isLoading
        || productsQuery.isLoading
        || orderItemsQuery.isLoading
        || newOrderQuery.isLoading
    ) {
        return <Skeleton active />
    }

    if (
        studentsQuery.isError
        || coursesQuery.isError
        || productsQuery.isError
        || orderItemsQuery.isError
        || newOrderQuery.isError
    ) {
        return <Result
            status="error"
            title={
                studentsQuery.error.message
                || coursesQuery.error.message
                || productsQuery.error.message
                || orderItemsQuery.error.message
                || newOrderQuery.error.message
            } />
    };

    const onSelectStudent = (value, option) => {
        const student = studentsQuery.data.find(f => f._id === value)
        form.setFieldsValue({
            lname_th: student.lname_th,
            phone: student.phone,
            parent_phone: student.parent.phone,
        })
    }
    const onSelectVat = (e) => {

        let grand_total = orderItemsQuery.data.reduce((prev, cur) => prev + (cur.quantity * cur.price), 0);
        let total = grand_total;
        let vat = 0;

        if (e.target.checked) {
            total = grand_total / 1.07;
            vat = grand_total - total;
        } else {
            total = grand_total;
            vat = 0;
        }
        form.setFieldsValue({
            // ...form.getFieldsValue(true),
            total,
            vat,
            grand_total
        });

    }

    const onFinish = async () => {
        try {
            await form.validateFields();

            const values = form.getFieldsValue(true);

            const payload = {
                ...values,
                student: values.fname_th,
                order_status: 'COMPLETED',
                order_date: values.order_date
                    ? values.order_date.format("YYYY-MM-DD")
                    : null
            };

            mutate(payload);

        } catch (err) {
            console.log(err);
            messageApi.open({
                type: 'error',
                content: 'Something went wrong please check you data or contact Admin.',
            });
        }
    };

    // console.log('newOrderQuery.data :', newOrderQuery.data);
    // console.log('orderItemsQuery.data :', orderItemsQuery.data);
    // console.log('stdudentsQuery.data :', studentsQuery.data);
    // console.log('coursesQuery.data :', coursesQuery.data);
    // console.log('productsQuery.data :', productsQuery.data);
    return (
        <div style={{
            background: '#fff',
        }}>
            {contextHolder}
            <Row justify='space-between' gutter={[16, 16]}>
                <Col xs={24}>
                    <Row justify='space-between'>
                        <Col>
                            <Typography.Title level={3}>
                                Add Order
                            </Typography.Title>
                        </Col>
                        {/* <Col>
                            <Button type='primary'>Add new student</Button>
                        </Col> */}
                    </Row>
                    <Typography.Title level={5}>
                        OrderNo. {newOrderQuery.data.order_no}
                    </Typography.Title>
                </Col>
                {/* <Divider /> */}
                <Col xs={24}>
                    <Form
                        name="createUser"
                        layout="vertical"
                        form={form}
                        initialValues={{
                            ...newOrderQuery.data,
                            total: orderItemsQuery.data.reduce((prev, cur) => prev + (cur.quantity * cur.price), 0),
                            grand_total: orderItemsQuery.data.reduce((prev, cur) => prev + (cur.quantity * cur.price), 0),
                            order_date: dayjs()
                        }}
                    >
                        <Row>
                            <Col xs={24} md={16}>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Date"
                                            name="order_date"
                                        >
                                            <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                                        </Form.Item>
                                    </Col>
                                    {/* <Col xs={24} md={12}></Col> */}
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="First Name (ภาษาไทย)"
                                            name="fname_th"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Select
                                                placeholder="Select student"
                                                showSearch
                                                optionFilterProp="children"
                                                onSelect={onSelectStudent}>
                                                {studentsQuery.data.map(student => <Select.Option key={student._id} value={student._id}>
                                                    {student.fname_th} {student.lname_th}
                                                </Select.Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    {/* <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Last Name (Thai)"
                                            name="lname_th"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col> */}
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Phone Number"
                                            name="phone"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Parent Phone"
                                            name="parent_phone"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Payment Type"
                                            name="payment_type"
                                        >
                                            <Select placeholder="Select payment type">
                                                {paymentTypes.map(type => <Select.Option key={type.value} value={type.value}>
                                                    {type.label_th}
                                                </Select.Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Vat. Include"
                                            name="is_vat"
                                            valuePropName="checked"
                                        >
                                            <Checkbox onChange={onSelectVat} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Form.Item
                                            label="Description"
                                            name="description"
                                        >
                                            <Input.TextArea rows={4} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col xs={24} md={16}>
                    <AddProduct
                        courses={coursesQuery.data}
                        products={productsQuery.data}
                        order={orderId}
                        form={form}
                    />
                </Col>
                <Col xs={24} md={16}>
                    <OrderItems orderItems={orderItemsQuery.data} orderId={orderId} form={form} />
                </Col>

                <Col xs={24} md={16}>
                    <Form form={form}>
                        <Row gutter={[8, 8]}>
                            <Col xs={24}>
                                <Row justify="end">
                                    <Col>
                                        <Typography.Paragraph style={{ margin: '0px 24px 0px 0px', padding: '0px' }}>ราคาสินค้าไม่รวม Vat (บาท) :</Typography.Paragraph>
                                    </Col>
                                    <Col >
                                        <Form.Item shouldUpdate>
                                            {() => {
                                                return <Statistic
                                                    value={form.getFieldValue('total').toFixed(2)}
                                                    precision={2}
                                                    valueStyle={{ fontSize: '14px', textAlign: 'end' }}
                                                />
                                            }}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24}>
                                <Row justify="end">
                                    <Col>
                                        <Typography.Paragraph style={{ margin: '0px 24px 0px 0px', padding: '0px' }}>ภาษีมูลค่าเพิ่ม 7% Vat (บาท):</Typography.Paragraph>
                                    </Col>
                                    <Col >
                                        <Form.Item shouldUpdate>
                                            {() => {
                                                return <Statistic
                                                    value={form.getFieldValue('vat').toFixed(2)}
                                                    precision={2}
                                                    valueStyle={{ fontSize: '14px', textAlign: 'end' }}
                                                />
                                            }}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={24}>
                                <Row justify="end">
                                    <Col>
                                        <Typography.Title level={5} style={{ margin: '0px 24px 0px 0px', padding: '0px' }}>ราคารวมสุทธิทั้งหมด(บาท) :</Typography.Title>
                                    </Col>
                                    <Col >
                                        <Form.Item shouldUpdate>
                                            {() => {
                                                return <Statistic
                                                    value={form.getFieldValue('grand_total')}
                                                    precision={2}
                                                    valueStyle={{ fontSize: '16px', textAlign: 'end', fontWeight: 600 }}
                                                />
                                            }}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                <Col xs={24} md={16}>
                    <Divider />
                </Col>
                <Col xs={24} md={16}>
                    <Row justify='end'>
                        <Col>
                            <Button
                                type="primary"
                                disabled={isLoading}
                                icon={<FaSave />}
                                onClick={onFinish}
                                style={{
                                    width: '100%',
                                    textTransform: 'capitalize'
                                }}
                            >
                                save
                            </Button>
                        </Col>
                    </Row>

                </Col>
            </Row>
        </div>
    )
}

export default Create